import React from 'react';
import { FaSpinner } from 'react-icons/fa';

const LoadingSpinner: React.FC = () => {
  return (
    <div className="spinner-container">
      <FaSpinner className="spinner text-white/30" />
    </div>
  );
};

export default LoadingSpinner;